<template>
  <div>
    <div
        class="flex flex-col items-center pb-5 xs:px-[20px] sm:px-[70px] md:px-[137px] lg:px-[172px] max-w-[1080px] mx-auto text-white">
      <p class="xs:text-[35px] sm:text-[35px] md:text-[33px] lg:text-[76px] text-center font-extrabold tracking-[-1.52px] xs:leading-[48px] sm:leading-[48px] md:leading-[48px] lg:leading-normal animate__animated animate__zoomIn">
        Which OCM strategy speaks your language?
      </p>
      <p class="xs:text-[17.5px] sm:text-[23px] md:text-[23px] lg:text-[38px] text-center font-semibold tracking-[-0.76px] mt-[10px] lg:mt-[33px]">
        Take this fast, fun quiz, discover and <span class="font-extrabold">WIN!</span>
      </p>
      <button @click="goToNextStep"
              class="xs:text-[19px] sm:text-[26px] md:text-[26px] lg:text-[42px] font-extrabold bg-[#E69F29] px-[15%] py-[10px] md:px-[90px] md:py-[12px] lg:px-[166px] lg:py-[25px] rounded-[53px] tracking-[-0.84px] mt-[30px] lg:mt-[80px]">
        START
      </button>
      <span
          class="xs:text-[16px] sm:text-[20px] md:text-[20px] lg:text-[34px] italic text-center opacity-50 tracking-[-0.68px] mt-[10px] sm:mt-[16px] md:mt-[16px] lg:mt-[18px]">
            (It only takes 30 seconds)
          </span>
    </div>

    <div class="circle-container px-[30px] md:px-[71px] max-w-[1080px]">
      <img src="@/assets/cyrcle-with-logo.png" alt="Background"/>

      <div class="orbit animate__animated animate__fadeIn">
        <img
            v-for="(item, index) in logos"
            :key="index"
            :src="item.src"
            :alt="item.name"
            :class="'logo pos-' + (index + 1)+''"
        />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Step1Page",
  data() {
    return {
      logos: [
        {name: "Adelaide", src: "/logos/adelaide.png"},
        {name: "Teads", src: "/logos/teads.png"},
        {name: "MadinAd", src: "/logos/madinad.png"},
        {name: "LUmen", src: "/logos/LUmen.png"},
        {name: "Storyteller", src: "/logos/storyteller.png"},
        {name: "AdSquirrel", src: "/logos/adsq.png"},
        {name: "Marketplace", src: "/logos/marketplace.png"},
      ],
    };
  },
  methods: {
    goToNextStep() {
      this.$emit('next-step');
    }
  }
};
</script>

<style scoped>
.circle-container {
  position: relative;
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.orbit {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo {
  height: 25px;
  position: absolute;
  transform-origin: center center;
  animation: orbit 23s linear infinite;
}

.logo.pos-1 {
  animation-delay: 0s;
}

.logo.pos-2 {
  animation-delay: -3.29s;
}

.logo.pos-3 {
  animation-delay: -6.57s;
}

.logo.pos-4 {
  animation-delay: -9.86s;
}

.logo.pos-5 {
  animation-delay: -13.14s;
}

.logo.pos-6 {
  animation-delay: -16.43s;
}

.logo.pos-7 {
  animation-delay: -19.71s;
}

@keyframes orbit {
  0% {
    transform: rotate(0deg) translateY(-85px) rotate(0deg);
  }
  100% {
    transform: rotate(360deg) translateY(-85px) rotate(-360deg);
  }
}

@media (min-width: 440px) {
  .logo {
    height: 30px;
  }

  @keyframes orbit {
    0% {
      transform: rotate(0deg) translateX(100px) rotate(0deg);
    }
    100% {
      transform: rotate(360deg) translateX(100px) rotate(-360deg);
    }
  }
}

@media (min-width: 540px) {
  .logo {
    height: auto;
  }

  @keyframes orbit {
    0% {
      transform: rotate(0deg) translateX(150px) rotate(0deg);
    }
    100% {
      transform: rotate(360deg) translateX(150px) rotate(-360deg);
    }
  }
}

@media (min-width: 640px) {
  .logo {
    height: auto;
  }

  @keyframes orbit {
    0% {
      transform: rotate(0deg) translateX(170px) rotate(0deg);
    }
    100% {
      transform: rotate(360deg) translateX(170px) rotate(-360deg);
    }
  }
}

@media (min-width: 940px) {
  .logo {
    height: auto;
  }

  @keyframes orbit {
    0% {
      transform: rotate(0deg) translateX(200px) rotate(0deg);
    }
    100% {
      transform: rotate(360deg) translateX(200px) rotate(-360deg);
    }
  }
}

@media (min-width: 1080px) {
  .logo {
    height: auto;
  }

  @keyframes orbit {
    0% {
      transform: rotate(0deg) translateX(200px) rotate(0deg);
    }
    100% {
      transform: rotate(360deg) translateX(200px) rotate(-360deg);
    }
  }
}
</style>